jQuery(document).ready(function($) {

  $('header').css('z-index', '999');
  $('.product-header_navigation').css('z-index', '100');

    //Owl
    $("#products-slider").owlCarousel({
      items: 1,
      nav: true,
      navText: ["<span></span>","<span></span>"],
      loop:true,
      center: true,
      startPosition: 1,
      dotsSpeed: 1500,
      navSpeed: 1500,
      mouseDrag: false,
      responsive:{
            900:{
                items: 3,
                nav: true,
                navText: ["<span></span>","<span></span>"],
                loop:true,
                center: true,
                startPosition: 1,
                dotsSpeed: 1500,
                navSpeed: 1500,
                 mouseDrag: false,
            },
        }
    });

    var owl;

    owl = $("#main-slider").owlCarousel({
      items: 1,
      nav: true,
      navText: ["<span></span>","<span></span>"],
      autoplay:true,
      loop:true,
      dotsSpeed: 1500,
      navSpeed: 1500,
      animateOut: 'fadeOut',
      animateIn: 'fadeIn',
      mouseDrag: false,
    });

    $('.banner-bottom_item:first-child').addClass('active');
    $('.banner-bottom_item').click(function () {
        $('.banner-bottom_item').removeClass('active');
        $(this).toggleClass('active');
        $('.owl-dot').eq($(this).index()).trigger('click');
    });

    $("#product-slider-owl").owlCarousel({
      items: 1,
      nav: true,
      navText: ["<span></span>","<span></span>"],
      loop:true,
      dotsSpeed: 0,
      navSpeed: 0,
      animateOut: 'fadeOut',
      animateIn: 'fadeIn',
      transitionStyle :"fade",
      mouseDrag: false,
      slideSpeed: 0,
      paginationSpeed: 0,
    });

    //Header scroll
    var lastScrollTop = 0;
    $(window).scroll(function(event){
       var st = $(this).scrollTop();
       if (st > lastScrollTop){
           $('header').addClass('down');
           $('header').removeClass('up');
           $('.product-header_navigation').addClass('down');
           $('.product-header_navigation').removeClass('up');
       } else {
        $('header').removeClass('down');
        $('header').addClass('up');
        $('.product-header_navigation').removeClass('down');
        $('.product-header_navigation').addClass('up');
       }
       lastScrollTop = st;
    });

    //Body click
    $('body').on('click', function() {
        $('.search-form').hide();
        $('.hidden__lang').hide();
        $('.language').removeClass('active');
        $('.lang__holder').removeClass('active');
    });

    $('.to-1').on('click', function(e) {
      e.preventDefault();
      $('.product-scroll_link').removeClass('active');
      $(this).addClass('active');
      $('html,body').animate({
          scrollTop: $('.product-slider').offset().top
        }, 1000);
    });

    $('.to-2').on('click', function(e) {
      e.preventDefault();
      $('.product-scroll_link').removeClass('active');
      $(this).addClass('active');
      $('html,body').animate({
          scrollTop: $('.product-feautures').offset().top
        }, 1000);
    });

    $('.to-3').on('click', function(e) {
      e.preventDefault();
      $('.product-scroll_link').removeClass('active');
      $(this).addClass('active');
      $('html,body').animate({
          scrollTop: $('.product-options').offset().top
        }, 1000);
    });

    $('.to-4').on('click', function(e) {
      e.preventDefault();
      $('.product-scroll_link').removeClass('active');
      $(this).addClass('active');
      $('html,body').animate({
          scrollTop: $('.complect-section').offset().top
        }, 1000);
    });

    $('.to-5').on('click', function(e) {
      e.preventDefault();
      $('.product-scroll_link').removeClass('active');
      $(this).addClass('active');
      $('html,body').animate({
          scrollTop: $('.gallery-section').offset().top
        }, 1000);
    });

    $('.mouse-icon').on('click', function() {
      $('html,body').animate({
          scrollTop: $('.products-section').offset().top
        }, 1000);
    });

    $('.product-left').hover(function() {
      $('#products-slider .owl-prev').css('opacity', '1');
    });
    $('.product-right').hover(function() {
      $('#products-slider .owl-next').css('opacity', '1');
    });

    $('.product-left').mouseleave(function(e) {
         $('#products-slider .owl-prev').css('opacity', '0');
    });
    $('.product-right').mouseleave(function(e) {
         $('#products-slider .owl-next').css('opacity', '0');
    });

    $('.product-left').click(function() {
      $('#products-slider .owl-prev').trigger('click');
    });
    $('.product-right').click(function() {
      $('#products-slider .owl-next').trigger('click');
    });
    
    //Language
    $('.language').on('click', function(e) {
      e.stopPropagation();
        $(this).toggleClass('active');
        $('.hidden__lang').toggle();
        $('.lang__holder').toggleClass('active');
    });

    //Header search
    $('.search-icon').on('click', function(e) {
        e.stopPropagation();
        $('.search-form').toggle();
    });
    $('.search-form').on('click', function(e) {
        e.stopPropagation();
    });

    //Scroll to top
    var btn = $('.to-top');
    $(window).scroll(function() {
        if ($(window).scrollTop() > 400) {
          btn.addClass('show');
        } else {
          btn.removeClass('show');
        }
    });

     $('.to-top').on('click', function(e) {
        e.preventDefault();
        $('body, html').animate({scrollTop: 0}, 1000);
     });

     //Tabs
     $(".cat-menu_description").not(":first").hide();
        $(".cat-menu_item").hover( function(e) {
        $(".cat-menu_item").removeClass("current").eq($(this).index()).addClass("current");
        $(".cat-menu_description").hide().eq($(this).index()).show();
      }).eq(0).addClass("current");

      $('.product-menu_link').mouseover( function(e) {
        e.stopPropagation();
        $(this).addClass('hovered');
        $('.products-submenu').css('display', 'flex');
      });

      $('.products-submenu').mouseover( function(e) {
        e.stopPropagation();
        $('.product-menu_link').addClass('hovered');
        $(this).css('display', 'flex');
      });

      $('.product-menu_link .sub-menu li').on('click', function(e) {
        e.stopPropagation();
      });

      $('.product-menu_link').mouseleave(function(e) {
        $('.products-submenu').css('display', 'none');
        $(this).removeClass('hovered');
      });

      $('.products-submenu').mouseleave(function(e) {
        $(this).css('display', 'none');
        $('.product-menu_link').removeClass('hovered');
      });

      //Video popup
      $('.g-column_1 .gallery-thumb').on('click', function(e) {
        e.preventDefault();
        if($(this).hasClass('video-thumb')) {
          $('.g-popup_1').fadeIn();
          $('.g-popup_1 .video-popup_content').eq($(this).index()).fadeIn();
        }
      });
      $('.g-column_2 .gallery-thumb').on('click', function(e) {
        e.preventDefault();
        if($(this).hasClass('video-thumb')) {
          $('.g-popup_2').fadeIn();
          $('.g-popup_2 .video-popup_content').eq($(this).index()).fadeIn();
        }
      });
      $('.g-column_3 .gallery-thumb').on('click', function(e) {
        e.preventDefault();
        if($(this).hasClass('video-thumb')) {
          $('.g-popup_3').fadeIn();
          $('.g-popup_3 .video-popup_content').eq($(this).index()).fadeIn();
        }
      });

      $('.close-video_popup').on('click', function(e) {
        e.preventDefault();
        $('.video-popup').fadeOut();
        $('.video-popup_content').fadeOut();
        $('iframe').each(function() {
          var video = $(this).attr("src");
          $(this).attr("src","");
          $(this).attr("src",video);
        })
      });

      //Mobile menu
       $('.hamburger').on('click', function(e) {
        e.stopPropagation();
        $('body').toggleClass('overflow');
        $(this).toggleClass('active');
        $('.mobile-menu').toggle();
       });

     if(innerWidth < 900) {
       $('.menu-item-has-children').on('click', function(e) {
        e.stopPropagation();
        $(this).toggleClass('active');
       });
     }

     //Viewbox
     $(".viewbox").viewbox();

});